import LegacySection from './LegacySection';

export * from './LegacySection';

export default LegacySection;
